import { useEffect, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import {
  Box,
  Card,
  Table,
  Switch,
  Button,
  TableBody,
  Container,
  TableContainer,
  TablePagination,
  FormControlLabel,
  InputAdornment,
  Stack,
  TextField,
} from '@mui/material';

import { useSnackbar } from 'notistack';
import { observer } from 'mobx-react-lite';
import MyDialog from 'src/components/MyDialog';
import StatusDelete from './FinancialPaymentDelete';

import FinancialPaymentTableRow from './FinancialPaymentTableRow';
import FinancialPaymentTableToolbar from './FinancialPaymentTableToolbar';
import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import Scrollbar from 'src/components/Scrollbar';
import { TableHeadCustom, TableEmptyRows, TableNoData } from 'src/components/table';
import useSettings from 'src/hooks/useSettings';
import useTable, { getComparator, emptyRows } from 'src/hooks/useTable';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import { useStore } from 'src/stores/store';
import { storeIdToLocalStorage } from 'src/Common/storeIdToLocalStorage';
import { useForm } from 'react-hook-form';
import LocalizDatePicker from 'src/sections/common/LocalizDatePicker';
import { IFinancialPayment } from 'src/@types/Choqorak/MainTables/FinancialPayment/FinancialPayment';

// ----------------------------------------------------------------------

export default observer(function FinancialPaymentList() {
  const { FinancialPaymentStore } = useStore();
  const { translate } = useLocales();
  const {
    loadFinancialPayment,
    FinancialPaymentList,
    FinancialPaymentRegistry,
    totalRecord,
    FinancialPaymentSearch,
    deleteFinancialPayment,
    getFinancialPaymentFromRegistry,
    setOpenCloseDialog,
    openDialog,
    loadFinancialPaymentDetail
  } = FinancialPaymentStore;
  const {
    dense,
    page,
    order,
    orderBy,
    rowsPerPage,
    setPage,
    onSort,
    onChangeDense,
    onChangeRowsPerPage,
  } = useTable();

  const { themeStretch, tablePagination, onChangePagination } = useSettings();

  const [filterName, setFilterName] = useState('');
  const [recieveDate, setRecieveDate] = useState<Date | null>(null);

  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const [financialPaymentId, setfinancialPaymentId] = useState<number>(0);
  const TABLE_HEAD = [
    { id: 'ID', label: `${translate('GeneralFields.No')}`, align: 'left' },
    { id: 'Date', label: `${translate('FinancialPayment.Date')}`, align: 'left' },
    // { id: 'Currency', label: `${translate('FinancialPayment.Currency')}`, align: 'left' },
    { id: 'Dollor', label: `${translate('Report.Dollor')}`, align: 'left' },
    { id: 'Afgani', label: `${translate('Report.Afghani')}`, align: 'left' },
    { id: 'Description', label: `${translate('FinancialPayment.Description')}`, align: 'left' },
    { id: '', label: `${translate('GeneralFields.Action')}` },
  ];
  const methods = useForm({

  });
  const { watch, control } = methods;
  const val = watch()
  const handleFilterName = () => {

    setPage(0);

    if ((filterName && filterName.length > 1) || val.recieveDate) {
      FinancialPaymentSearch({
        pageIndex: 0,
        pageSize: tablePagination,
        searchBy: filterName || undefined,
        paymentDate: val.recieveDate ? val.recieveDate : undefined,
      });
    } else if (!filterName && !val.recieveDate) {
      FinancialPaymentSearch({ pageIndex: 0, pageSize: tablePagination });
    }
  };

  const ResetList = () => {


    FinancialPaymentSearch({ pageIndex: 0, pageSize: tablePagination });

  };



  const handleOpenConfirm = (id: number) => {
    setOpenCloseDialog();
    setfinancialPaymentId(id);
  };

  const handleCloseConfirm = () => {
    setOpenCloseDialog();
  };
  const handleEditRow = (id: number) => {
    getFinancialPaymentFromRegistry(id);
    navigate(PATH_DASHBOARD.FinancialPayment.edit);
  };

  const handleDetail = (id: number) => {
    storeIdToLocalStorage(id, FinancialPaymentStore);
    loadFinancialPaymentDetail(id);
    navigate(PATH_DASHBOARD.FinancialPayment.detail);
  };
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    loadFinancialPayment({ pageIndex: newPage, pageSize: tablePagination });
  };
  const handlePageSizeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangePagination(event.target.value);

    onChangeRowsPerPage(event);
    let pageZize = parseInt(event.target.value);
    loadFinancialPayment({ pageIndex: 0, pageSize: pageZize });
  };

  useEffect(() => {
    onChangeRowsPerPage(tablePagination);
    loadFinancialPayment({ pageIndex: 0, pageSize: tablePagination });
  }, [loadFinancialPayment, tablePagination]);

  useEffect(() => {
    if (FinancialPaymentRegistry.size <= 1) {
      loadFinancialPayment({ pageIndex: 0, pageSize: rowsPerPage });
    }
  }, []);

  const dataFiltered = applySortFilter({
    tableData: FinancialPaymentList,
    comparator: getComparator(order, orderBy),
    filterName: '',
  });

  const denseHeight = dense ? 52 : 72;

  const isNotFound = !dataFiltered.length && !!filterName;


  return (
    <Page title={translate('FinancialPayment.Title')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('FinancialPayment.FinancialPaymentList')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },

            { name: `${translate('FinancialPayment.FinancialPaymentList')}` },
          ]}
          action={
            <>
              <PermissionBasedGuard permissions={['FinancialPayment-Create']}>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  component={RouterLink}
                  to={PATH_DASHBOARD.FinancialPayment.new}
                >
                  {translate('CRUD.Create')}
                </Button>
              </PermissionBasedGuard>
            </>
          }
        />

        <Card>
          {/* <FinancialPaymentTableToolbar filterName={filterName} onFilterName={handleFilterName} control={control} /> */}
          <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }}
            sx={{
              display: 'grid',
              columnGap: 2,
              rowGap: 3,
              gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(4, 1fr)' },
              py: 2.5, px: 3
            }}
          >
            <LocalizDatePicker
              name="recieveDate"
              label={translate('FinancialPayment.Date')}
              control={control}


            />
            <TextField
              fullWidth
              value={filterName}
              onChange={(e) => setFilterName(e.target.value)}

              placeholder={translate('FinancialPayment.Placeholder')}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify
                      icon={'eva:search-fill'}
                      sx={{ color: 'text.disabled', width: 20, height: 20 }}
                    />
                  </InputAdornment>
                ),
              }}
            />
            <Box>
              <Button
                sx={{ width: '120px', margin: '2px', padding: '10px' }}
                variant="contained"
                onClick={ResetList}
                startIcon={<Iconify icon="eva:refresh-outline" />}
                size='large'
                color='warning'
              >
                {translate('CRUD.Reset')}
              </Button>
              <Button
                sx={{ width: '120px' }}
                variant="contained"
                onClick={handleFilterName}
                startIcon={<Iconify icon="eva:search-fill" />}
                size='large'
              >
                {translate('Report.Filter')}
              </Button>
            </Box>
          </Stack>
          <Scrollbar>
            <TableContainer sx={{ maxHeight: 600, minWidth: 960, position: 'relative' }}>
              <Table stickyHeader size={dense ? 'small' : 'medium'}>
                <TableHeadCustom
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={totalRecord}
                  onSort={onSort}
                />

                <TableBody>
                  {dataFiltered
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <FinancialPaymentTableRow
                        key={row.financialPaymentId}
                        row={row}
                        index={index}
                        handleDetail={() => handleDetail(row.financialPaymentId!)}
                        onDeleteRow={() => handleOpenConfirm(row.financialPaymentId!)}
                        onEditRow={() => handleEditRow(row.financialPaymentId!)}
                      />
                    ))}

                  <TableEmptyRows
                    height={denseHeight}
                    emptyRows={emptyRows(page, rowsPerPage, totalRecord)}
                  />

                  <TableNoData isNotFound={isNotFound} />
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <Box sx={{ position: 'relative' }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]}
              component="div"
              labelRowsPerPage={translate('Pagination.RowsPerPage')}
              count={totalRecord}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} ${translate('Pagination.Of')} ${count}`
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handlePageSizeChange}
            />
            <MyDialog
              open={openDialog}
              onClose={handleCloseConfirm}
              title={translate('CRUD.DeleteTitle')}
              size="md"
            >
              <StatusDelete id={financialPaymentId} />
            </MyDialog>
            <FormControlLabel
              control={<Switch checked={dense} onChange={onChangeDense} />}
              label={translate('Pagination.Dense')}
              sx={{ px: 3, py: 1.5, top: 0, position: { md: 'absolute' } }}
            />
          </Box>
        </Card>
      </Container>
    </Page>
  );
});

// ----------------------------------------------------------------------

function applySortFilter({
  tableData,
  comparator,
  filterName,
}: {
  tableData: IFinancialPayment[];
  comparator: (a: any, b: any) => number;
  filterName: string;
}) {
  const stabilizedThis = tableData.map((el, index) => [el, index] as const);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  tableData = stabilizedThis.map((el) => el[0]);

  if (filterName) {
    tableData = tableData.filter(
      (item: Record<string, any>) =>
        item.searchBy.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
    );
  }

  return tableData;
}
